import store from '@/store';

export default {
	async favourOrUnfavourCluster(parent, clusterId, isFavourite, notifyZone) {
		try{
				await parent.$confirm(
					isFavourite ? 'Are you sure you want to add to favourites collection?':'Are you sure you want to remove from favourites collections?',
					'Confirmation',
					'question',
					{
						confirmButtonText: 'Yes',
            cancelButtonText: 'No',
					},
				);
		}
		catch{
			return
		}

		try{
				let response
				response = await store.dispatch('manageClusterFavouriteMiddleware', {
										isFavourite: isFavourite,
										clusterId: clusterId
								});
				if (response.success) {
						parent.updateShowedElements(true, 'Favourite')
						parent.activeClustersHoverActive = false
						parent.favouriteClustersHoverActive = true
						parent.allClustersHoverActive = false
						parent.archivedClustersHoverActive = false
						parent.isLoading = false;
						const successText = response.message
						const successTitle = 'CLUSTER FAVOURITES MANAGEMENT'
						parent.$notifTerm.addNotification(parent.$notifTerm.typesNotif.SUCCESS, successTitle, successText, notifyZone)
				}
				else {
						const errText = response.message
						const errTitle = 'Operation Failed'
						parent.$notifTerm.addNotification(parent.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone)
						return
				}
		}catch{
					const errText = 'Something went wrong in middle of the process'
					const errTitle = 'Operation Failed'
					parent.$notifTerm.addNotification(parent.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone)
					return
		}
	}
}
